const EXPIRING_SOON_DAYS = 7
const MS_PER_DAY = 24 * 60 * 60 * 1000

const utcDay = (date: Date) => Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate())

/**
 * Presentation rule for the expiring-soon badge: the learner's access ends fewer than seven days
 * from today. Compared by calendar day, so the badge does not turn on and off with the clock.
 *
 * This decorates the served state for display only - it does not re-derive the course's status.
 */
export const isExpiringSoon = (availableUntil: string | null | undefined): boolean => {
  if (!availableUntil) {
    return false
  }

  const expiry = new Date(availableUntil)
  if (Number.isNaN(expiry.getTime())) {
    return false
  }

  const daysLeft = (utcDay(expiry) - utcDay(new Date())) / MS_PER_DAY
  return daysLeft >= 0 && daysLeft < EXPIRING_SOON_DAYS
}
